import { render } from "./NavContent.vue?vue&type=template&id=457ef5dd"
import script from "./NavContent.vue?vue&type=script&lang=js"
export * from "./NavContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__